export const actualVersusTheoreticalConfig = {
  title: "Actual Versus Calculated Consumption Data",
  storageKey: "actualVersusTheoreticalDates",
  excelConfig: {
    getHeaders: (data, reportType, capitalizeWords) => {
      if (reportType === "daily") {
        return [
          "Branch Name", "Branch Code", "Store Name", "Store Code", "City", "State", "Country", "Item Name", "Item Code", "Unit", "Unit Cost", "Opening Stock", 
          "Transfer In", "Closing Stock", "Actual Quantity", "Theoretical Quantity", "Consumption Discrepancy",
          "Percentage Of Consumption Discrepancy (%)", "Per Day Consumption Discrepancy",
          "Price Discrepancy", "Opening Stock Date", "Closing Stock Date"
        ];
      }

      return Object.keys(data[0]).map(capitalizeWords);
    },

    mapRow: (item, reportType, formatValue) => {
      if (reportType === "daily") {
        return [
          item.branch_name,
          item.branch_code,
          item.store_name,
          item.store_code,
          item.city,
          item.state,
          item.country,
          item.item_name,
          item.item_code,
          item.unit,
          formatValue(item.unit_cost),
          formatValue(item.opening_stock),
          formatValue(item.transfer_in),
          formatValue(item.closing_stock),
          formatValue(item.actual_quantity),
          formatValue(item.theoretical_quantity),
          formatValue(item.consumption_discrepancy),
          formatValue(item.percentage_of_consumption_discrepancy),
          formatValue(item.consumption_discrepancy_per_day),
          formatValue(item.price_discrepancy),
          item.opening_stock_date,
          item.closing_stock_date
        ];
      }

      return Object.values(item).map(val =>
        typeof val === "string" && val.startsWith("'")
          ? parseFloat(val.slice(1))
          : formatValue(val)
      );
    }
  },
  apiPayloadBuilder: ({ start_date, end_date, outlets }) => ({
    start_date,
    end_date,
    consumptionType: "Actual Versus Theoretical",
    outlets
  }),
};
